import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "~/Containers/ContainerCreate";
import { getTopArtists } from "~/api/getStats";

class TopArtistsContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const artists = (data && data.data) || {};
    return render({ artists, loading, failure });
  };
}

export default CreateContainer(getTopArtists, TopArtistsContainer);
